module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/winter-right-icon-70ed2106f74facabc574c76d0d92a826.svg";